import { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "../components/translate/i18";
import Alert from "../common/Alert/index";
import { InboxProvider } from "../components/InboxProvider/InboxProvider";
import useNotifications from "../hooks/useNotifications";

const DefaultLayout = () => {
  const { t, i18n } = useTranslation();

  const { token, notification } = useNotifications();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [headerOpen, setHeaderOpen] = useState(false);
 

  const location = useLocation();

  const isDashboard = location.pathname === "/home";



  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div
        className={`flex flex-1 overflow-hidden ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
          }`}
      >
        <InboxProvider>
          <I18nextProvider i18n={i18n}>

            <Sidebar
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
            />
            <div className="relative flex flex-1 flex-col overflow-hidden">

              <Header
                className="sticky top-0 z-50"
                headerOpen={headerOpen}
                setHeaderOpen={setHeaderOpen}
                token={token}
                notification={notification}
              />
              <main className="flex-1 overflow-y-auto overflow-x-hidden">

                <div className="w-full h-full p-2 md:p-5 2xl:p-10">

                  <Outlet />
                </div>
              </main>
              <Alert /> <Footer className="sticky bottom-0" />
            </div>
          </I18nextProvider>
        </InboxProvider>
      </div>
    </div>
  );
};

export default DefaultLayout;
